<template>
	<div class="booking-component component-view fullscreen">
		<div class="container-fluid">
			<div class="row">
				<div class="col py-10">
					<LanguageSwitcher v-show="false"></LanguageSwitcher>

					<div class="text-center">
						<img src="/assets/images/hellers24.svg" class="logo"/>
					</div>

					<div class="content login-form">
						<table class="w-300 mx-auto mt-30">
							<tr>
								<td colspan="2" class="text-center"><h2 class="header">Login</h2></td>
							</tr>
							<tr>
								<td colspan="2" class="text-center pb-6 terminal">
									<a v-for="(conf, key) in availableConfigurations"
										@click="setConfiguration(key)"
										class="btn btn-primary mx-3" :class="{selected:currentConfigKey==key}">
										{{ conf.title }}
									</a>
								</td>
							</tr>
							<tr>
								<th>Username</th>
								<td><input type="text" v-model="userName" class="p-8" data-height="0" @focus="show" data-layout="compact" @keyup.prevent="keyPressed" /></td>
							</tr>
							<tr>
								<th>Passwort</th>
								<td><input type="password" v-model="userPassword" class="p-8" data-height="0" @focus="show" data-layout="compact" @keyup.prevent="keyPressed" /></td>
							</tr>
							<tr>
								<td colspan="2">
									<div class="btn-wrap text-center pt-5">
										<a class="btn btn-primary btn-gold" @click="checkLogin('fe')">Login Frontend</a> &nbsp; <a class="btn btn-primary btn-gold" @click="checkLogin('be')">Login Backend</a>
									</div>
								</td>
							</tr>
						</table>
						<div class="error text-center font-weight-bold text-danger pt-10" v-show="error">Zugangsdaten leider falsch!</div>
					</div>


				</div>
			</div>
		</div>
		<div class="keyboard-container" :class="{'show-keyboard': visible, 'numeric-keyboard': isNumeric}">
			<vue-touch-keyboard id="keyboard" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input" />
		</div>
	</div>
</template>

<script>

	import Vue from 'vue'
	import axios from 'axios'
	import LanguageSwitcher from './../components/languageswitcher.vue'

	import { mapState } from 'vuex';
	import { configurations, API_URI } from "@/common/config";
	import VueTouchKeyboard from "vue-touch-keyboard";

	Vue.use(VueTouchKeyboard)

	export default {
		props: [],
		data: function () {
			return {
				currentConfigKey: '',
				availableConfigurations: {},
				userName: null,
				userPassword: null,
				error: false,
				/* VUE TOUCH KEYBOARD */
				visible: false,
				isNumeric: false,
				layout: 'normal',
				input: null,
				options: {
					useKbEvents: false
				},
				nnLayoutCompact: {
					_meta: {
						"default": {keySet: "default", text: "abc", classes: "control"},
						"alpha": {keySet: "default", text: "Abc", classes: "control"},
						"shift": {keySet: "shifted", text: "ABC", classes: "control"},
						"numbers": {keySet: "numbers", text: "123", classes: "control"},
						"space": {key: " ", text: "Space", width: 200},
						"backspace": {func: "backspace", classes: "control"},
						"accept": {func: "accept", text: "Close", classes: "control featured"},
						"next": {func: "next", text: "Next", classes: "featured"},
						"zero": {key: "0", width: 130}
					},

					default: [
						"1 2 3 4 5 6 7 8 9 0 {backspace}",
						"Q W E R T Y U I O P Ü",
						"A S D F G H J K L Ö Ä",
						"Z X C V B N M ẞ '",
						"- . {space} @ {accept}"
					],

					shifted: [
						"Q W E R T Y U I O P",
						" A S D F G H J K L ",
						"{default} Z X C V B N M ",
						"{numbers} _ {space} {backspace} {accept}"
					],

					numbers: [
						"1 2 3",
						"4 5 6",
						"7 8 9",
						". {zero} {backspace} {accept}"
					]
				},
				nnLayoutNumeric: {
					_meta: {
						"backspace": { func: "backspace", classes: "control"},
						"accept": { func: "accept", text: "Close", classes: "control featured"},
						"next": { func: "next", text: "Next", classes: "control featured"},
						"zero": { key: "0", width: 90}
					},

					default: [
						"1 2 3",
						"4 5 6",
						"7 8 9",
						"- . {zero} {backspace} {accept}"
					]
				}


			}
		},
		computed: {
			...mapState('settings', ['config']),
		},

		mounted: function() {
			this.availableConfigurations = configurations;
			this.setDefaultConfiguration();
		},

		components: {
			LanguageSwitcher
		},
		methods: {

			/**
			 * Find configuration for current host.
			 * Set switcher to default selection depending
			 * on the host.
			 *
			 */
			setDefaultConfiguration() {
				for (var confName in configurations) {
					var conf = configurations[confName];
					if (window.location.hostname == conf.hostName) {
						return this.setConfiguration( confName );
					}
				}
				this.setConfiguration( Object.keys(configurations).shift() );
			},

			setConfiguration(confName) {
				this.currentConfigKey = confName;
				this.$store.commit('settings/SET_CONFIG', configurations[confName]);
				this.$store.commit( 'localSettings/MODIFY', {configKey:confName} );
				this.$store.dispatch('localSettings/SAVE');
			},

			/** Keyboard Events **/
			accept(text) {
				// console.log("Input text: " + text);
				this.hide();
			},
			show(e) {
				this.input = e.target;
				this.layout = e.target.dataset.layout;
				if(e.target.dataset.layout == 'numeric') {
					this.layout = this.nnLayoutNumeric;
					this.isNumeric = true;
				} else {
					this.isNumeric = false;
				}

				if(e.target.dataset.layout == 'compact') {
					this.layout = this.nnLayoutCompact;
				}

				this.fieldHeightText = 'transform:translateY('+e.target.dataset.height+'px)';

				if (!this.visible)
					this.visible = true
			},

			hide() {
				this.visible = false;
				this.fieldHeightText = 'transform:translateY(0)';
			},


			checkLogin: function(target) {
				let formData = new FormData();
				formData.append('user', this.userName);
				formData.append('pwd', this.userPassword);
				formData.append('target', target);

				axios({
					method: 'post',
					url: this.config.apiUrl + 'checkLogin',
					data: formData
				}).then(response => (
						this.userCheck(response.data)
				));
			},

			userCheck: function(data) {
				if(typeof data.authUser == 'object' && typeof data.authUser.access_token == 'string') {
					this.error = false;
					window.localStorage.setItem('authUser',JSON.stringify(data.authUser));

					var redirectUrl = window.location.protocol + "//" + window.location.host + "/#/" + data.authUser.path;

					var cookieData = null;

					// console.log(window.location.host);
					cookieData = 'PHPSESSID='+data.authUser.session_id+';domain='+ window.location.host;
					document.cookie = cookieData;

					//cookieData = 'PHPSESSID='+data.authUser.session_id+';domain=.'+ window.location.host;
					//document.cookie = cookieData;

					window.document.location.href = redirectUrl;
				} else {
					this.error = true;
				}
			},

			keyPressed: function(e) {
				if (e.keyCode === 13) {
					this.checkLogin(this.userName, this.userPassword);
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.booking-component .saveAllBookings .btn-success {
		border-radius: 0;
	}

	.booking-component .saveAllBookings {
		text-align: center;
	}

	td {
		input {
			font-size: 40px;
		}
	}

	th {
		text-align: inherit;
		font-size: 40px;
		padding-right: 20px;
	}
</style>

<style lang="scss">
	.logo {
		max-width: 150px;
	}


	.vdp-datepicker .form-control {
		font-size: 1rem;
		padding: .375rem .75rem;
		-webkit-box-shadow: none;
		box-shadow: none;
		background: #fff;
		letter-spacing: 0;
	}

	.booking-component .form-control {
		border-radius: 0;
	}

	.booking-component input,
	.booking-component select.form-control {
		height: 34px;
		min-width: 64px;
	}


	/* Style the tabs */

	#tabs {

	}

	.tabs {
			overflow: hidden;
	}

	.tabs ul {
			list-style-type: none;
			margin-left: 20px;
	}

	.tabs a{
			background: linear-gradient(90deg,#989fa4,#c8d3d9,#989fa4);
			color: #000 !important;
			float: left;
			cursor: pointer;
			padding: 12px 24px;
			// transition: background-color 0.5s linear;

			-webkit-transition: background 1s ease-out;
			-moz-transition: background 1s ease-out;
			-o-transition: background 1s ease-out;
			transition: background 1s ease-out;

			border-right: none;
			font-weight: normal;
	}
	.tabs a:last-child {
			border-right: 1px solid #383639;
	}

	.tabs a:not(:last-child)  {
		margin-right: 0.75rem;
	}

	/* Change background color of tabs on hover */
	.tabs a:hover {
			background: linear-gradient(90deg,#72767a,#a6adb1,#7a8185);
	}

	/* Styling for active tab */
	.tabs a.active {
			background: linear-gradient(90deg,#b78417,#feef9f,#b78417);
			// font-weight: bold;
			cursor: default;

	}

	/* Style the tab content */
	.tabcontent {
			padding-top: .75rem;
	}

	.terminal {
		a {
			cursor: pointer;
			&, &:hover {
				background: #d1ac4f;
			}
			border: none;
			color: #000 !important;
			opacity: 0.4;
			&.selected, &:hover {
				opacity: 1;
			}
		}
	}
</style>
